import PropTypes from 'prop-types';
import React, {useRef, useState} from 'react';
import {Fab, Tooltip, alpha, getOverlayAlpha} from '@mui/material';

const MapTool = ({
  active,
  icon,
  onClick,
  sx,
  tooltipTitle = '',
  tooltipPosition = 'left',
  visible = true,
  ...props
}) => {
  const [onHover, setOnHover] = useState(false);
  const target = useRef(null);

  return (
    <Tooltip
      open={!active && onHover}
      title={tooltipTitle}
      placement={tooltipPosition}
    >
      <Fab
        size="small"
        ref={target}
        onMouseEnter={() => setOnHover(true)}
        onMouseLeave={() => setOnHover(false)}
        onFocus={() => setOnHover(true)}
        onBlur={() => setOnHover(false)}
        onClick={evt => {
          // ensure the target is always the outlying button
          onClick({...evt, target: target.current});
        }}
        sx={[
          theme => ({
            backgroundColor: 'background.paper',
            borderRadius: 1,
            color: active ? 'primary.main' : 'text.primary',
            display: visible ? 'inherit' : 'none',
            ...(theme.palette.mode === 'dark'
              ? {
                  ':hover': {
                    backgroundColor: theme.palette.background.paper,
                    backgroundImage: `linear-gradient(${alpha(
                      '#fff',
                      theme.palette.action.hoverOpacity,
                    )}, ${alpha('#fff', theme.palette.action.hoverOpacity)})`,
                  },
                }
              : {}),
            '&.Mui-disabled': {
              color: theme.palette.action.disabled,
              backgroundColor:
                theme.palette.mode === 'dark'
                  ? theme.palette.background.paper
                  : 'grey.400',
              backgroundImage: `linear-gradient(${alpha(
                '#fff',
                getOverlayAlpha(10),
              )}, ${alpha('#fff', getOverlayAlpha(10))})`,
            },
          }),
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
        {...props}
      >
        {icon}
      </Fab>
    </Tooltip>
  );
};

MapTool.propTypes = {
  /**
   * If `true`, the button is rendered in an active state.
   */
  active: PropTypes.bool,
  /**
   * Icon element.
   */
  icon: PropTypes.element,
  /**
   * Callback fired when the component is clicked
   */
  onClick: PropTypes.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.object,
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  tooltipTitle: PropTypes.string,
  /**
   * Tooltip placement.
   */
  tooltipPosition: PropTypes.string,
  /**
   * If `true`, the component is shown
   */
  visible: PropTypes.bool,
};

export default MapTool;
